module.exports = __webpack_public_path__ + "img/online_order.32a16c5b.jpg";